import { nonUndefined } from "Utility";
import { FsWorldTourScoring } from "db/model/match/Set/WorldTour/FsWorldTourScoring";
import { WorldTourScoring } from "model/Match/Set/WorldTour/Format/WorldTourScoring";

export const mapWorldTourScoring = (
  fsModel: FsWorldTourScoring
): WorldTourScoring => {
  const keys = Object.keys(fsModel);
  const scoring: WorldTourScoring = {};
  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];
    const scores = fsModel[key];
    if (!scores) {
      continue;
    }

    scoring[key] = nonUndefined(scores);
  }

  return scoring;
};
